import computed from "./computed";
import methods from "./methods";

/**
 * BURGER BUTTON
 *
 * The Burger Button Component renders the typical burger navigation toggler for
 * small devices. Its state is maintained in Vuex Store, since it needs to be
 * updated programatically from other parts of the code (e.g Router's Navigation
 * Guards. See @/router/index.js)
 *
 */
export default {
	name: "BurgerButton",
	computed,
	methods,
};
